import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Icon = styled(FontAwesomeIcon)({
    fontSize: 20,
    color: '#fff',
    margin: '4px auto',
});

export const Wrapper = styled.div`
    align-items: center;
    justify-content: center;
    background: #0D6EFD;
    border-radius: 8px;
    display: flex;
    position: fixed;
    left: 0;
    right: 0;
    top: 70px;
    margin: auto;
    width: fit-content;
    height: 20px;
    z-index: 100;
    padding: 9px 12px;
`

export const Text = styled.p`
    color: #fff;
    font-weight: 600;
    font-size: 15px;
    margin-left: 12px;
    margin-bottom: 3px;
`